module.exports = __webpack_public_path__ + "static/media/build_business.73ee1be2.svg";